/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const GetTrustdockVerifications200ResponseIdDocumentRecordsInnerResultOneOf = {
    approved: 'approved',
    denied: 'denied'
} as const;

export type GetTrustdockVerifications200ResponseIdDocumentRecordsInnerResultOneOf = typeof GetTrustdockVerifications200ResponseIdDocumentRecordsInnerResultOneOf[keyof typeof GetTrustdockVerifications200ResponseIdDocumentRecordsInnerResultOneOf];



